import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { useServiceList } from '@/modules/Service/hooks'
import { DEVICE_LIQUIDATION_STATUSES } from '@/modules/Service/utils/service-list-config'

const DeviceLiquidation = () => {
    const {
        services,
        pagination,
        stateComponent,
        isFetching,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        filterItems,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useServiceList({
        type: 'device-liquidation',
        serviceStatuses: DEVICE_LIQUIDATION_STATUSES,
        showAccountManager: false,
        showDateFilters: false,
    })

    // Filter columns for device liquidation view
    const visibleColumns = columns.filter(
        (col) =>
            ![
                'name',
                'service_stopped_date',
                'service_active_cycling',
                'service_renew_cycling',
            ].includes(col.key as string)
    )

    return (
        <Paper>
            <FilterBar
                control={control}
                setFilter={setFilter}
                items={filterItems}
                hideSearch
            />

            {stateComponent || (
                <DataTableCustomized
                    columns={visibleColumns}
                    rows={services}
                    rowKey={(row) => String(row?.service_id)}
                    size="small"
                    resizable
                    loading={!services.length && !pagination}
                    isFetching={isFetching}
                    emptyMessage={t('no-services')}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    pagination={{
                        page: params.page || 1,
                        pageSize: params.page_size || 20,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                        pageSizeOptions: [10, 20, 50, 100],
                    }}
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search-service'),
                        },
                        settings: {
                            show: true,
                            storageKey: 'services-device-liquidation-list',
                        },
                    }}
                />
            )}
        </Paper>
    )
}

export default DeviceLiquidation
